<template>
  <div class="container py-3">
    <br>
    <div class="row">
      <div class="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center">
        <span class="fa-stack fa-2x mb-3">
          <i class="fal fa-circle fa-stack-2x text-danger"></i>
          <i class="fal fa-traffic-light-stop fa-stack-1x text-danger"></i>
        </span>
        <h1 class="h2">Ouch...</h1>
        <p class="lead grey px-5">We can't find the trailer you're looking for.</p>

        <p>It's probably our fault. We'll fix it swiftly 👊</p>
        <hr>
        <p>
          <small>
            <router-link class="blue" to="/trailers">← Back to trailers</router-link>
          </small>
        </p>
        <p class="small grey">Debug ID: <span class="easy-select">{{ payload.assetId }}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['payload'],
    mounted() {
      this.$store.commit('meta/title', 'Trailer not found: ' + this.payload.assetId)
    },
}
</script>
